import { all } from 'redux-saga/effects'

import { editCashInstrumentRootSaga } from '../state/edit-cash-instruments-slice'

export function* rootSaga() {
  yield all([editCashInstrumentRootSaga()])
}
